import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap'
import Blog from './Blog'
import styled from 'styled-components';
import { ButtonR } from '../ButtonElement';
import { Link } from 'react-router-dom';
import { db } from '../../firebase';
import { useAuth } from '../../context/AuthContext';

export const NavLogo = styled(Link)`
 color: #fff;
 display:flex;
 justify-self:flex-start;
 align-items:center;
 margin-left:24px;
 font-weight:bold;
 text-decoration:none;
 cursor: pointer;
 &:hover{
     text-decoration:none;
     color:#fff;
 }
`
function Articles() {
  const [blogs, setBlogs] = useState([]);
  const { currentUser } = useAuth();
  const [userRole, setUserRole] = useState();
  useEffect(() => {
    db.collection('blogs').onSnapshot(snapshot => {
      setBlogs(snapshot.docs.map(doc => ({ id: doc.id, title: doc.data().title, body: doc.data().body, author: doc.data().author })));
    });
  }, []);
  useEffect(() => {
    if (currentUser == null) { }
    else {
      var docRef = db.collection("users").doc(currentUser.uid);
      docRef.get().then(function (doc) {
        if (doc.exists) {
          // console.log("Document data:", doc.data());
          setUserRole(doc.data().role);
          console.log(userRole);
        } else {
          console.log("No such document!");
        }
      }).catch(function (error) {
        console.log("Error getting document:", error);
      });
    }
  }, [currentUser, userRole]);

  return (
    <Container style={{ minHeight: "100vh", minWidth: "100vw", backgroundColor: '#01bf71', overflowY: 'hidden' }}>
      <NavLogo to="/" style={{ position: "absolute", marginTop: '20px' }}> MindSpace   <span style={{ fontStyle: "italic", fontSize: '14px' }}> Blogs</span></NavLogo>
      {userRole === 'therapist' ? < ButtonR to="/upload-blog" style={{ position: "absolute", marginTop: '20px', marginRight: '0px', marginLeft: '50%' }} >Upload Blog</ButtonR> : null}
      <Container style={{ marginTop: '100px' }}>
        {blogs.map(blog => {
          return <Blog key={blog.id} blog={blog} />
        })}
      </Container>
    </Container >
  )
}

export default Articles;
